// extracted by mini-css-extract-plugin
module.exports = {"modal":"View_modal__1sx8X","wrapper":"View_wrapper__nHix7"};